import { render, staticRenderFns } from "./AccountPermissionsDialog.vue?vue&type=template&id=79dfe782"
import script from "./AccountPermissionsDialog.vue?vue&type=script&lang=js"
export * from "./AccountPermissionsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports